import { _baseGetFetch, _basePostFetch, _basePutFetch, _baseDeleteFetch, ApiEnum, _basePatchFetch } from './baseFetch'
import { getUrl } from 'aws-amplify/storage'
const fileAPI = process.env.REACT_APP_CONTAINER_API_GATEWAY

export const getFirmwareList = () => {
  return _baseGetFetch(`/products/firmware-downloads`)
}

export const getUserProductFirmware = (userUuid, serialNumber, queryParams) => {
  return _baseGetFetch(`/users/${userUuid}/products/${serialNumber}/firmware-downloads`, queryParams)
}

export const getUserProductsFirmwareUpdateStatus = (userUuid) => {
  return _baseGetFetch(`/users/${userUuid}/products/firmware/update-available`)
}

export const downloadFirmware = async (fid, filename, filepath, body) => {
  if (filename?.length > 0 && filepath?.length > 0) {
    const result = await getUrl({
      path: `${filepath}/${filename}`,
    })
    window.open(result.url.toString(), '_blank')
  } else {
    window.open(`${fileAPI}/firmware-download/files?fid=${fid}`).focus()
  }

  downloadCounter(fid)
  return trackDownload(body)
}

export const trackDownload = (body) => {
  return _basePostFetch(`/products/firmware-downloads/tracking`, body)
}

const downloadCounter = (fid) => {
  return _basePutFetch(`/products/firmware-downloads/files/${fid}`)
}

export const getFirmwareReleases = async (queryParams) => {
  return _baseGetFetch(`/firmware/releases`, { ...queryParams, maxResults: 20 }, ApiEnum.admin)
}

export const getFirmwareUploadFiles = async (queryParams) => {
  return _baseGetFetch(`/firmware/files`, { ...queryParams, maxResults: 20 }, ApiEnum.admin)
}

export const getFirmwareUploadDocuments = async (queryParams) => {
  return _baseGetFetch(`/firmware/documents`, { ...queryParams, maxResults: 20 }, ApiEnum.admin)
}

export const getFirmwarePrefixes = async () => {
  return _baseGetFetch(`/firmware/prefixes`, undefined, ApiEnum.admin)
}

export const getFirmwareTypes = async () => {
  return _baseGetFetch(`/firmware/types`, undefined, ApiEnum.admin)
}

export const getFirmwareReleasesById = async (id) => {
  return _baseGetFetch(`/firmware/releases/${id}`, undefined, ApiEnum.admin)
}

export const getRevisionNumberValidation = async (prefix, revisionNr) => {
  return _baseGetFetch(`/firmware/prefixes/${prefix}/revisions`, { revisionNumber: revisionNr }, ApiEnum.admin)
}

export const postRelease = async (bodyParams) => {
  return _basePostFetch(`/firmware/releases`, bodyParams, ApiEnum.admin)
}

export const putRelease = async (releaseId, bodyParams) => {
  return _basePutFetch(`/firmware/releases/${releaseId}`, bodyParams, ApiEnum.admin)
}

export const patchFirmwareFile = async (fileId, bodyParams) => {
  return _basePatchFetch(`/firmware/${fileId}`, bodyParams, ApiEnum.admin)
}

export const patchFirmwareDocument = async (fileId, bodyParams) => {
  return _basePatchFetch(`/firmware/documents/${fileId}`, bodyParams, ApiEnum.admin)
}

export const deleteRelease = async (releaseId) => {
  return _baseDeleteFetch(`/firmware/releases/${releaseId}`, undefined, ApiEnum.admin)
}

export const deleteFirmwareFile = async (fileId) => {
  return _baseDeleteFetch(`/firmware/${fileId}`, undefined, ApiEnum.admin)
}

export const deleteFirmwareDocument = async (fileId) => {
  return _baseDeleteFetch(`/firmware/documents/${fileId}`, undefined, ApiEnum.admin)
}

